/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var Navigation = {};

( function( $ ) {

	// Navigation.init = function() {
	// 	$( '.navbar-nav ul li:first-child ul' ).show();
	// };

	// Navigation.onHover = function() {
	// 	$( '.dropdown-toggle, .dropdown-menu' ).hover( function() {
	// 		if( Viewport.documentWidth().width <= 767 ) {
	// 			return;
	// 		}
	// 		$( this ).parent().addClass( 'open' );
	// 	}, function() {
	// 		$( this ).parent().removeClass( 'open' );
	// 	} );
	// };

	// Navigation.desktop = function() {
	// 	var style = document.createElement( 'style' );

	// 	document.head.appendChild( style );
	// 	sheet = style.sheet;

	// 	if( $( '.navbar-nav li.active ul.dropdown-menu' ).length ) {
	// 		sheet.addRule( '.navbar .container .navbar-collapse .navbar-nav li.active>a:before', 'border-width: 0 9px 8px 9px;' );
			
	// 		$( 'html body' ).find( 'div.sub-nav' ).show();
	// 		$( '.navbar-nav li.active a:before' ).show();
	// 	} else {
	// 		var active = $( '.navbar .container .navbar-collapse .navbar-nav li.active' );
			
	// 		if( active.hasClass( 'active-aca-subnav' ) ) {
	// 			sheet.addRule( '.navbar .container .navbar-collapse .navbar-nav li.active>a:before', 'border-width: 0 9px 8px 9px;' );
				
	// 			$( 'html body' ).find( 'div.sub-nav' ).show();
				
	// 			return;
	// 		}
			
	// 		sheet.addRule( '.navbar .container .navbar-collapse .navbar-nav li.active>a:before', 'display: none;' );
	// 	}

	// };

	// Navigation.mobile = function() {
	// 	var menuActive = $( '.navbar-nav li.active' );

	// 	menuActive.find( 'a span.caret' ).css( 'display', 'inline-block' );

	// 	var currentScroll = 0;

	// 	$( '.navbar-collapse' ).on( 'shown.bs.collapse', function() {
	// 		currentScroll = $( window ).scrollTop();
			
	// 		$( 'html, body' ).addClass( 'disable-scroll' );
	// 	} );

	// 	$( '.navbar-collapse' ).on( 'hide.bs.collapse', function() {
	// 		$( 'html, body' ).removeClass( 'disable-scroll' );
			
	// 		$( window ).scrollTop( currentScroll );
	// 	} );
	// };

	// $( document ).ready( function() {
	// 	Navigation.init();
	// 	Navigation.onHover();

	// 	if( Viewport.documentWidth().width > 767 ) {
	// 		Navigation.desktop();
	// 	} else {
	// 		Navigation.mobile();
	// 	}
	// } );
} )( jQuery );
